module.exports = __webpack_public_path__ + "static/media/IMG_2725.377d6e44.JPG";